import { create } from 'zustand';
import type { Profile } from '@/types';

interface UserState {
  profile: Profile | null;
  loading: boolean;
  authStuck: boolean;  // 🆕 Telegram-авторизация зависла
  setProfile: (p: Profile | null) => void;
  setLoading: (b: boolean) => void;
  setAuthStuck: (b: boolean) => void;  // 🆕
  patchProfile: (patch: Partial<Profile>) => void;
}

export const useUserStore = create<UserState>((set) => ({
  profile: null,
  loading: true,
  authStuck: false,  // 🆕
  setProfile: (p) => set({ profile: p }),
  setLoading: (b) => set({ loading: b }),
  setAuthStuck: (b) => set({ authStuck: b }),  // 🆕
  patchProfile: (patch) =>
    set((s) => (s.profile ? { profile: { ...s.profile, ...patch } } : s)),
}));
